import { getItem } from "../services/localStorageService";
import { LOCAL_STORAGE_KEYS } from "../consts/constants";

export default function getRefreshToken() {
  return getItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN) || "";
}

